import { IApi } from '../../api'
import { createRequestTypes } from '../../helpers/helpers'
import { createAction } from '../types'

export const prefix = 'file'

const UPLOAD = createRequestTypes(prefix, 'UPLOAD')
export const [UPLOAD_REQUEST, UPLOAD_SUCCESS, UPLOAD_FAILURE] = UPLOAD

export const uploadFile = createAction((data: FormData) => ({
  type: UPLOAD,
  promise: (api: IApi) => api.file.upload(data),
}))

const UPDATE = createRequestTypes(prefix, 'UPDATE')
export const [UPDATE_REQUEST, UPDATE_SUCCESS, UPDATE_FAILURE] = UPDATE

export const updateFile = createAction((id: string, data: object) => ({
  type: UPDATE,
  promise: (api: IApi) => api.file.update(id, data),
}))

const DELETE = createRequestTypes(prefix, 'DELETE')

export const [DELETE_REQUEST, DELETE_SUCCESS, DELETE_FAILURE] = DELETE

export const deleteFile = createAction((id: string | string[]) => ({
  type: DELETE,
  promise: (api: IApi) => api.file.delete(id),
  // Carry the deleted ids so reducers (e.g. the task panel's file list) can drop
  // them from the store without a refetch.
  params: { ids: Array.isArray(id) ? id : [id] },
}))

const LIST_HEADER_MAPPING = createRequestTypes(prefix, 'LIST_HEADER_MAPPING')

export const [
  LIST_HEADER_MAPPING_REQUEST,
  LIST_HEADER_MAPPING_SUCCESS,
  LIST_HEADER_MAPPING_FAILURE,
] = LIST_HEADER_MAPPING

export const listHeaderMapping = createAction((params: object) => ({
  type: LIST_HEADER_MAPPING,
  promise: (api: IApi) => api.file.listHeaderMapping(params),
}))

const UPDATE_HEADER_MAPPING = createRequestTypes(prefix, 'UPDATE_HEADER_MAPPING')

export const [
  UPDATE_HEADER_MAPPING_REQUEST,
  UPDATE_HEADER_MAPPING_SUCCESS,
  UPDATE_HEADER_MAPPING_FAILURE,
] = UPDATE_HEADER_MAPPING

export const updateHeaderMapping = createAction((id: string, data: object) => ({
  type: UPDATE_HEADER_MAPPING,
  promise: (api: IApi) => api.file.updateHeaderMapping(id, data),
}))

const CREATE_HEADER_MAPPING = createRequestTypes(prefix, 'CREATE_HEADER_MAPPING')

export const [
  CREATE_HEADER_MAPPING_REQUEST,
  CREATE_HEADER_MAPPING_SUCCESS,
  CREATE_HEADER_MAPPING_FAILURE,
] = CREATE_HEADER_MAPPING

export const createHeaderMapping = createAction((data: object) => ({
  type: CREATE_HEADER_MAPPING,
  promise: (api: IApi) => api.file.createHeaderMapping(data),
}))

export const RESET_HEADER_MAPPING = `${prefix}/RESET_HEADER_MAPPING`

export const resetHeaderMapping = () => ({
  type: RESET_HEADER_MAPPING,
})
